<template>
  <div>
    <v-layout wrap>
      <v-flex xs12 sm12>
        <div>
          <div xs12 sm6 class="pa-2">
            <div class="form-control" style="display: inline-block">
              <input v-model="search" type="text" placeholder="Search" />
            </div>
          </div>
          <div xs12 sm6 class="text-xs-left text-sm-right">
            <v-btn @click="deleteclearcartslive" outline color="grey">
              <v-icon class="mr-2">delete</v-icon>Clear all cart
            </v-btn>
            <v-btn
              :disabled="!selected.length"
              @click="showsend(false)"
              :loading="allsendloading"
              depressed
              color="primary"
            >
              <v-icon class="mr-2">email</v-icon>Send order summary
            </v-btn>
          </div>
        </div>
        <div class="text-xs-right ma-2">
          ลูกค้าทั้งหมด:
          <span
            style="font-weight: 500;"
            class="primary--text"
          >{{filteredItems.length | numberFormat}}</span>
        </div>
        <div class="text-xs-right ma-2">
          สินค้าทั้งหมด:
          <span
            style="font-weight: 500;"
            class="primary--text"
          >{{totalquantity | numberFormat}}</span>
        </div>
        <div>
          <v-data-table
            v-model="selected"
            :headers="headers"
            v-bind:pagination.sync="pagination"
            :items="filteredItems"
            flat
            select-all
            item-key="userid"
          >
            <template v-slot:headers="props">
              <tr>
                <th>
                  <v-checkbox
                    :input-value="props.all"
                    :indeterminate="props.indeterminate"
                    primary
                    hide-details
                    @click.stop="toggleAll"
                    color="primary"
                  ></v-checkbox>
                </th>
                <th
                  v-for="(header,k) in props.headers"
                  :key="k"
                  :class="[
              'column sortable',
              pagination.descending ? 'desc' : 'asc',
              header.value === pagination.sortBy ? 'active' : ''
            ]"
                  @click="changeSort(header.value)"
                >
                  <v-icon small>arrow_upward</v-icon>
                  {{ header.text }}
                </th>
              </tr>
            </template>
            <template v-slot:items="props">
              <tr :active="props.selected" @click="props.selected = !props.selected">
                <td>
                  <v-checkbox :input-value="props.selected" color="primary" hide-details></v-checkbox>
                </td>
                <td>
                  <v-avatar color="grey" size="40">
                    <img
                      class="responsive-img circle"
                      style="min-width: 100%"
                      alt
                      :src="props.item.photourl"
                    />
                  </v-avatar>
                </td>
                <td class="text-xs-center">{{ props.item.facebookname?props.item.facebookname:'-' }}</td>
                <td
                  v-if="props.item.quantity"
                  class="text-xs-center"
                >{{ props.item.quantity | numberFormat }}</td>
                <td v-else class="text-xs-center">-</td>
                <td
                  v-if="props.item.amount"
                  class="text-xs-center"
                >{{ props.item.amount | numberFormat }}</td>
                <td v-else class="text-xs-center">-</td>
                <td>
                  <v-btn
                    @click.stop="showsend(props.item.userid)"
                    depressed
                    color="primary"
                    small
                    fab
                    outline
                  >
                    <v-icon small>email</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </v-flex>
    </v-layout>
    <v-dialog width="1000px" persistent v-model="messageshow">
      <v-card>
        <div class="text-xs-right">
          <v-btn @click="messageshow = false" icon>
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <h5 class="mb-3 mt-0">{{$t('Send Order Summary')}}</h5>
          <div class="px-4">
            <v-layout row wrap>
              <v-flex xs6>
                <div>ส่งปุ่มชำระเงินอัตโนมัติ</div>
                <div>
                  <label class="toggle-switch small">
                    <input
                      @input="changebtnsendcartstatus"
                      v-model="btnsendcartstatus"
                      type="checkbox"
                    />
                    <span class="toggle-slider lever round"></span>
                  </label>
                </div>
              </v-flex>
              <v-flex xs6>
                <!-- <label class="toggle-switch small">
                  <input
                    @input="changebtnsendcartstatus"
                    v-model="btnsendcartstatus"
                    type="checkbox"
                  />
                  <span class="toggle-slider lever round"></span>
                </label>-->
              </v-flex>
            </v-layout>
          </div>
          <MessagePattern :pattern.sync="pattern"></MessagePattern>
          <div class="text-xs-center">
            <v-btn
              :loading="sendloading"
              :disabled="!pattern"
              @click="sendordersummary(sendtype)"
              depressed
              color="primary"
            >send</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import { setInterval, clearInterval } from 'timers'
import MessagePattern from './MessagePattern'

export default {
  components: {
    MessagePattern
  },
  data() {
    return {
      sendtype: '',
      btnsendcartstatus: true,
      pattern: '',
      currentuserid: '',
      sendloading: false,
      messageshow: false,
      getdatainterval: '',
      selected: [],
      search: '',
      allsendloading: false,
      pagination: { sortBy: 'id', descending: true, rowsPerPage: 5 },
      headers: [
        {
          text: '',
          sortable: false
        },
        {
          text: 'Name',
          value: 'facebookname'
        },
        {
          text: 'Quantity',
          value: 'quantity',
          align: 'right'
        },
        {
          text: 'Amount',
          value: 'amount',
          align: 'right'
        },
        { text: '', sortable: false }
      ],
      items: []
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    filteredItems() {
      var items = this.items

      items = this.items.filter(el => {
        if (this.search) {
          if (el.facebookname) {
            return el.facebookname.toLowerCase().includes(this.search.toLowerCase())
          } else return false
        } else return true
      })
      return items
    },
    totalquantity() {
      if (this.filteredItems.length) {
        var total = this.filteredItems.reduce((a, b) => {
          return { quantity: parseInt(a.quantity) + parseInt(b.quantity) }
        })
        return total.quantity
      } else return 0
    }
  },
  mounted() {
    this.getData()
    this.getdatainterval = setInterval(() => {
      this.getData()
    }, 10000)
  },
  beforeDestroy() {
    clearInterval(this.getdatainterval)
  },
  methods: {
    changebtnsendcartstatus(e) {
      this.btnsendcartstatus = e.target.checked
    },
    showsend(userid) {
      if (userid) this.currentuserid = userid
      else this.sendtype = 'all'
      this.messageshow = true
    },
    deleteclearcartslive() {
      var vm = this
      this.$swal
        .fire({
          type: 'question',
          title: 'คุณต้องการเคลียร์ตะกร้าทั้งหมดหรือไม่?',
          showCancelButton: true,
          confirmButtonText: vm.$t('Yes'),
          cancelButtonText: vm.$t('No'),
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            api.deleteclearcartslive({ pageid: this.selectedBot.pageid }, (err, response) => {
              this.items = []
            })
          }
        })
    },
    getData() {
      api.getusercartslive({ pageid: this.selectedBot.pageid }, (err, response) => {
        if (response.responsecode == 200) {
          if (response.data) {
            this.items = response.data
          } else {
            this.items = []
          }
        }
      })
    },
    sendordersummary(sendtype) {
      if (sendtype == 'all') this.sendOrderSummaryToAll(this.pattern)
      else this.sendordersummarybyuser(this.currentuserid, this.pattern)
    },
    sendordersummarybyuser(userid, type) {
      this.sendloading = true
      api.postsendordersummarybyuser(
        {
          pageid: this.selectedBot.pageid,
          userid,
          type,
          btnsendcartstatus: this.btnsendcartstatus
        },
        async (err, response) => {
          this.sendloading = false
          await this.$swal.fire({
            type: 'success',
            title: 'ส่งข้อความสำเร็จ'
          })
          this.messageshow = false
        }
      )
    },
    sendOrderSummaryToAll(type) {
      this.sendloading = true
      var userid
      if (this.selected && this.selected.length) {
        userid = this.selected
          .map(el => {
            return el.userid
          })
          .join(',')
      } else {
        userid = this.items
          .map(el => {
            return el.userid
          })
          .join(',')
      }
      api.postsendordersummaryall(
        {
          pageid: this.selectedBot.pageid,
          userid,
          type,
          btnsendcartstatus: this.btnsendcartstatus
        },
        async (err, response) => {
          this.sendloading = false
          await this.$swal.fire({
            type: 'success',
            title: 'ส่งข้อความสำเร็จ'
          })
          this.messageshow = false
        }
      )
    },
    toggleAll() {
      if (this.selected.length) this.selected = []
      else this.selected = this.items.slice()
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/live/CartManagement.vue